module.exports = __webpack_public_path__ + "static/img/icon cd kf.fb9391d4.svg";